import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../services/auth-service';
import { CommonModule } from '@angular/common';
import { NgForm } from '@angular/forms';
import { LoginModel } from '../models/login.model';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { EmployeeService } from '../services/employee-service';

@Component({
  selector: 'app-login',
  standalone: true,           // <-- standalone component
  imports: [CommonModule, FormsModule, MatSnackBarModule],     // <-- import FormsModule here
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {

  constructor(private api: AuthService, private router: Router, private snackBar: MatSnackBar, private employeeService:EmployeeService) { }
  loginRequest: LoginModel = {
    usertype: 'Vendor',
    login: '',
    password: ''
  };
  isLoading = false;
  ngOnInit() {
    localStorage.clear();
    sessionStorage.clear();
  }

  onSubmit() {
    if (!this.loginRequest.login || !this.loginRequest.password || !this.loginRequest.usertype) {
      return;
    }
    if (this.isLoading) return; // Prevent multiple clicks
    this.isLoading = true;    
    if(this.loginRequest.usertype=="Vendor"){
    this.api.authenticate(this.loginRequest).subscribe({
      next: (res) => {
        this.isLoading = false;
        if (res && res.result.status == 200 && res.result.message == 'Login successful') {
          sessionStorage.setItem("token", res.result.token);
          sessionStorage.setItem("userType", 'Vendor');
          if (res.result) {
            sessionStorage.setItem("user_code", res.result.user_data.vendor_code);
            sessionStorage.setItem("user_name", res.result.user_data.vendor_name);
          }
          this.router.navigate(['/dashboard']);
        }
        else {
          this.snackBar.open('Login failed. Please check your credentials.', 'Close', {
            duration: 3000,
            panelClass: ['error-snackbar']
          });
        }
      },
      error: (err) => {
        this.isLoading = false;
      }
    });
  }
  else{
    this.loginRequest.usertype='Employee';
     this.employeeService.authenticate(this.loginRequest).subscribe({
      next: (res) => {
        this.isLoading = false;
        if (res && res.result.status == 200 && res.result.message == 'Login successful') {
          sessionStorage.setItem("token", res.result.token);
          sessionStorage.setItem("userType", 'Employee');
          if (res.result) {
            sessionStorage.setItem("user_code", res.result.user_data.employee_code);
            sessionStorage.setItem("user_name", res.result.user_data.employee_name);
          }
          // this.router.navigate(['/dashboard']);
          this.router.navigate(['/leave-request']);
        }
        else {
          this.snackBar.open('Login failed. Please check your credentials.', 'Close', {
            duration: 3000,
            panelClass: ['error-snackbar']
          });
        }
      },
      error: (err) => {
        this.isLoading = false;
      }
    });
  }
  }
} 
